import {
  Modal as MantineModal,
  type ModalProps as MantineModalProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type ModalProps = CoreComponentProps<MantineModalProps, 'div'>;

export function Modal({ testId, view = "all", ...rest }: ModalProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineModal data-testid={testId} {...rest} />;
}
